(function () {
  'use strict';

  function initFlocage(scope) {
    var containers = (scope || document).querySelectorAll('.flocage');
    containers.forEach(function (container) {
      if (container._flocageInit) return;
      container._flocageInit = true;

      var items          = container.querySelectorAll('.flocage__item');
      var basePriceCents = parseInt(container.dataset.basePrice || '0', 10);
      var originalPriceText = null;

      // ─── Affichage du prix sur la fiche produit ───────────────────────────
      function getPriceEl() {
        return document.querySelector('product-price [ref="priceContainer"] .price');
      }

      function updatePriceDisplay() {
        var priceEl = getPriceEl();
        if (!priceEl) return;
        if (originalPriceText === null) {
          originalPriceText = priceEl.textContent.trim();
          if (!basePriceCents) basePriceCents = parseInt(originalPriceText.replace(/[^0-9]/g, ''), 10) || 0;
        }
        var extra = 0;
        items.forEach(function (item) {
          var inp = item.querySelector('.flocage__input');
          if (inp && inp.value.trim()) extra += parseInt(item.dataset.price || '0', 10);
        });
        var el = getPriceEl();
        if (!el) return;
        if (extra === 0) { el.textContent = originalPriceText; return; }
        var t = basePriceCents + extra;
        var str = Math.floor(t / 100) + ',' + (t % 100 < 10 ? '0' : '') + (t % 100);
        el.textContent = originalPriceText.indexOf('€') === 0 ? '€' + str : str + ' €';
      }

      // ─── Accordéon ────────────────────────────────────────────────────────
      items.forEach(function (item) {
        var toggle = item.querySelector('.flocage__toggle');
        var body   = item.querySelector('.flocage__body');
        var input  = item.querySelector('.flocage__input');
        var chars  = item.querySelector('.flocage__chars');
        var maxLen = input ? parseInt(input.getAttribute('maxlength') || '0', 10) : 0;

        function openItem() {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
          if (input) setTimeout(function () { input.focus(); }, 200);
        }
        function closeItem() {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = '0';
        }

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          item.classList.contains('is-open') ? closeItem() : openItem();
        });

        if (input && item.dataset.digits === 'true') {
          input.setAttribute('inputmode', 'numeric');
          input.setAttribute('pattern', '[0-9]*');
          input.addEventListener('input', function () {
            var sel = input.selectionStart;
            var cleaned = input.value.replace(/[^0-9]/g, '');
            if (cleaned !== input.value) {
              input.value = cleaned;
              try { input.setSelectionRange(Math.max(0, sel - 1), Math.max(0, sel - 1)); } catch(x) {}
            }
          });
        }

        if (input) {
          input.addEventListener('input', function () {
            if (chars && maxLen > 0) {
              var left = maxLen - input.value.length;
              chars.textContent = left + ' caractère' + (left > 1 ? 's' : '') + ' restant' + (left > 1 ? 's' : '');
            }
            updatePriceDisplay();
            if (item.classList.contains('is-open')) body.style.maxHeight = body.scrollHeight + 'px';
          });
        }
      });

      // ─── Helpers panier ───────────────────────────────────────────────────
      function getForm() {
        return document.querySelector('form[data-type="add-to-cart-form"]') ||
               document.querySelector('product-form-component form');
      }

      function getVariantId() {
        var form = getForm();
        if (!form) return null;
        var el = form.querySelector('[ref="variantId"]') || form.querySelector('[name="id"]');
        return el ? el.value : null;
      }

      function getQuantity() {
        var form = getForm();
        if (!form) return 1;
        var el = form.querySelector('[name="quantity"]');
        return el ? (parseInt(el.value) || 1) : 1;
      }

      // Collecte les options remplies par le client
      function getFilledOptions() {
        var options = [];
        items.forEach(function (item) {
          var input = item.querySelector('.flocage__input');
          if (!input || !input.value.trim()) return;
          options.push({
            key:       input.getAttribute('name').replace('properties[', '').replace(']', ''),
            value:     input.value.trim(),
            variantId: parseInt(item.dataset.variant || '0', 10)
          });
        });
        return options;
      }

      // Rafraîchit le mini-panier / cart drawer après ajout
      function refreshCart() {
        // 1. Tente de rafraîchir via le système de sections Shopify
        fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var refreshed = false;
            Object.keys(data).forEach(function(sectionId) {
              var html = data[sectionId];
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');

              // Mise à jour du cart drawer
              var newDrawer = doc.querySelector('[id^="cart-drawer"]') ||
                              doc.querySelector('cart-drawer-component') ||
                              doc.querySelector('.cart-drawer');
              var oldDrawer = document.querySelector('[id^="cart-drawer"]') ||
                              document.querySelector('cart-drawer-component') ||
                              document.querySelector('.cart-drawer');
              if (newDrawer && oldDrawer) {
                oldDrawer.innerHTML = newDrawer.innerHTML;
                refreshed = true;
              }

              // Mise à jour du compteur panier
              var newCount = doc.querySelector('.cart-count-bubble, [data-cart-count], .cart-icon-bubble');
              var oldCount = document.querySelector('.cart-count-bubble, [data-cart-count], .cart-icon-bubble');
              if (newCount && oldCount) oldCount.innerHTML = newCount.innerHTML;
            });

            // 2. Tente d'ouvrir le drawer
            if (refreshed) {
              var drawerEl = document.querySelector('cart-drawer-component') ||
                             document.querySelector('[id*="CartDrawer"]') ||
                             document.querySelector('.cart-drawer');
              if (drawerEl) {
                // Déclenche les events standards
                ['cart:open', 'cart:refresh', 'shopify:cart:change'].forEach(function(evtName) {
                  document.dispatchEvent(new CustomEvent(evtName, { bubbles: true }));
                });
                // Cherche et clique le bouton d'ouverture du panier
                var cartBtn = document.querySelector('[aria-controls*="cart"], [data-cart-toggle], .cart-icon-link');
                if (cartBtn) cartBtn.click();
              }
            } else {
              // Fallback : redirection vers /cart
              window.location.href = '/cart';
            }
          })
          .catch(function() {
            window.location.href = '/cart';
          });
      }

      // ─── Interception de l'ajout au panier ────────────────────────────────
      var productFormComponent = document.querySelector('product-form-component');
      if (!productFormComponent) return;

      // On intercepte le submit du formulaire (capture phase = avant Clarity)
      var form = getForm();
      if (!form) return;

      form.addEventListener('submit', function (e) {
        var filledOptions = getFilledOptions();

        // Pas d'options flocage → on laisse Clarity gérer normalement
        if (filledOptions.length === 0) return;

        // Sinon on prend le contrôle
        e.preventDefault();
        e.stopPropagation();

        var variantId = getVariantId();
        var quantity  = getQuantity();
        if (!variantId) {
          window.location.href = '/cart';
          return;
        }

        // Construire les propriétés du maillot principal
        var properties = {};
        filledOptions.forEach(function(opt) { properties[opt.key] = opt.value; });

        // Construire le tableau d'items : maillot principal + add-ons
        var cartItems = [{
          id:         parseInt(variantId),
          quantity:   quantity,
          properties: properties
        }];

        filledOptions.forEach(function(opt) {
          if (opt.variantId) {
            cartItems.push({
              id:         opt.variantId,
              quantity:   1,
              properties: { '_pour': 'personnalisation maillot' }
            });
          }
        });

        // Désactiver le bouton pendant la requête
        var addBtn = form.querySelector('[name="add"], button[type="submit"]');
        if (addBtn) addBtn.disabled = true;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body:    JSON.stringify({ items: cartItems })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (addBtn) addBtn.disabled = false;
          if (data.status && data.status >= 400) {
            console.error('[Flocage] Erreur cart/add.js :', data);
            alert(data.description || 'Erreur lors de l\'ajout au panier.');
            return;
          }
          refreshCart();
        })
        .catch(function (err) {
          if (addBtn) addBtn.disabled = false;
          console.error('[Flocage] Erreur réseau :', err);
          window.location.href = '/cart';
        });

      }, true); // capture phase
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFlocage(); });
  } else { initFlocage(); }
  document.addEventListener('shopify:section:load', function (e) { initFlocage(e.target); });
})();